export class ArrayUtils{

    public static findValue(array:Object[], value:string){
        return array.filter(function(obj){
            //loop through each object
            for(var key  in obj){
              if ( obj[key] instanceof String){
                if(obj[key].toString().toUpperCase().includes(value.toUpperCase())){
                    return obj;
                } 
              }else{
                if(obj[key].toString().toUpperCase().includes(value.toUpperCase())){
                  return obj;
                } 
              }
            }    
          });   
    }
    
}